import { render, staticRenderFns } from "./SkuInfoItemThree.vue?vue&type=template&id=42a2d2b9&scoped=true"
import script from "./SkuInfoItemThree.vue?vue&type=script&lang=js"
export * from "./SkuInfoItemThree.vue?vue&type=script&lang=js"
import style0 from "./SkuInfoItemThree.vue?vue&type=style&index=0&id=42a2d2b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a2d2b9",
  null
  
)

export default component.exports